export var Runtime;
(function (Runtime) {
    Runtime.debounce = (() => (exec, timeout = 1000) => {
        let id = undefined;
        return () => {
            clearTimeout(id);
            id = setTimeout(exec, timeout);
        };
    })();
    Runtime.scheduleInterval = (exec, time, ...args) => {
        const id = setInterval(exec, time, ...args);
        return { terminate: () => clearInterval(id) };
    };
    Runtime.scheduleTimeout = (exec, time, ...args) => {
        const id = setTimeout(exec, time, ...args);
        return { terminate: () => clearTimeout(id) };
    };
})(Runtime || (Runtime = {}));
